module.exports = Promise.all([__parcel__import__("ieiaO"), __parcel__import__("8HOtg")]).then(() => parcelRequire('g36Vt'));